// docs/real-estate/be/10-api-reference.md §A12. `opts`:
//   appointment_type: 'viewing' (default) | 'key_handover'
//   duration_minutes: required for key_handover, forbidden on a viewing
//   agent_id: optional — narrows to one agent (agent-mode/handover only)
import { request } from './http';

export function getAvailableDates(pid, { fromDate, toDate, ...opts }) {
  return request({
    path: `/properties/${pid}/availability/dates`,
    params: { from_date: fromDate, to_date: toDate, ...opts },
  });
}

export function getAvailableSlots(pid, { date, ...opts }) {
  return request({
    path: `/properties/${pid}/availability/slots`,
    params: { date, ...opts },
  });
}
